enum PeriodUnits {
  weeks,
  months,
  quarters,
  years,
}
export default PeriodUnits;
